import { z } from "zod/v4";

// IBE config schema is a loose object to allow for more flexible configuration
// this means that the schema is not strict and allows for unknown keys
// this is to allow for future compatibility with old configs
export const IBEConfigSchema = z.looseObject({
    propertyId: z.string().optional(),
    propertyGroupId: z.string().optional(),
    primaryColor: z.string().optional(),
});

export type TIBEConfig = z.infer<typeof IBEConfigSchema>;
